module.exports = __webpack_public_path__ + "static/media/playIcon.ad41dec9.svg";